import React from 'react'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { connect } from 'react-redux'
import { UserRoles } from '@chegg-wt/core/constants/user'
import { UpgradePromotionBoxCopy } from '@chegg-wt/core/types/copy'
import { userRoleSelector } from '@chegg-wt/core/state/user/selectors'
import AppLink from '../AppLink'
import * as Styled from './styled'

export const UPGRADE_CARD_LEARN_MORE = 'upgrade-learn-more-button'

const UpgradePromotionBox: React.FunctionComponent<UpgradePromotionBoxCopy> = ({
  buttonText,
  mainHeading,
  subHeading,
  homePage = false,
  userRole = UserRoles.NOT_LOGGED_IN,
}) => {
  const { toUpgradeCTA } = useRoutesContext()

  return userRole === UserRoles.PRO_USER ? null : (
    <Styled.CardWrapper homePage={homePage}>
      <Styled.Heading>{mainHeading}</Styled.Heading>
      <Styled.SubHeading>{subHeading}</Styled.SubHeading>
      <AppLink route={toUpgradeCTA()}>
        <Styled.RedirectButton data-test={UPGRADE_CARD_LEARN_MORE}>
          {buttonText}
        </Styled.RedirectButton>
      </AppLink>
    </Styled.CardWrapper>
  )
}

const mapStateToProps = (state) => ({
  userRole: userRoleSelector(state),
})

export default connect(mapStateToProps, null)(UpgradePromotionBox)
